import { SpacerState } from './../types/state';
export const defaultSpacerState: SpacerState = {
  height: 24,
};
